import React, { useState } from 'react';  // Adicionado useState
import PropTypes from 'prop-types';
import {
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
  CircularProgress,
  Typography,
  Box,
  Chip,
  Button  // Adicionado Button
} from '@mui/material';
import {
  Add as AddIcon,  // Adicionado
  Remove as RemoveIcon  // Adicionado
} from '@mui/icons-material';
import { formatarData } from '../../utils/formatters';
import { FORMATOS_DATA } from '../../config/constants';

const EstudantesAtivosTable = ({ estudantes, loading, error, tipoInstituicao }) => {
  const [showAll, setShowAll] = useState(false);
  const estudantesExibidos = showAll ? estudantes : estudantes?.slice(0, 5);
  const temMaisEstudantes = estudantes?.length > 5;

  if (loading) {
    return (
      <Box display="flex" justifyContent="center" p={3}>
        <CircularProgress />
      </Box>
    );
  }

  if (error) {
    return (
      <Box p={3}>
        <Typography color="error">{error}</Typography>
      </Box>
    );
  }

  if (!estudantes?.length) {
    return (
      <Box p={3} textAlign="center">
        <Typography color="text.secondary">
          Nenhum estudante ativo encontrado
        </Typography>
      </Box>
    );
  }

  return (
    <>
      <TableContainer component={Paper} sx={{ borderRadius: 2, boxShadow: 1 }}>
        <Table>
          <TableHead>
            <TableRow>
              <TableCell>Nome</TableCell>
              <TableCell>Matrícula</TableCell>
              <TableCell>
                {['COLEGIO', 'EXTERNATO'].includes(tipoInstituicao) ? 'Classe' : 'Curso'}
              </TableCell>
              <TableCell>Data de Ingresso</TableCell>
              <TableCell align="center">Status</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {estudantesExibidos.map((estudante) => (
              <TableRow 
                key={estudante.id}
                sx={{ '&:last-child td, &:last-child th': { border: 0 } }}
              >
                <TableCell>{estudante.nome}</TableCell>
                <TableCell>{estudante.matricula}</TableCell>
                <TableCell>{estudante.infoAdicional}</TableCell>
                <TableCell>
                  {formatarData(estudante.dataIngresso, FORMATOS_DATA.PADRAO)}
                </TableCell>
                <TableCell align="center">
                  <Chip
                    label={estudante.status}
                    color="success"
                    size="small"
                    variant="outlined"
                    sx={{ minWidth: 85 }}
                  />
                </TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </TableContainer>

      {/* Botão Ver Todos e contador */}
      <Box sx={{ 
        mt: 2, 
        display: 'flex', 
        justifyContent: 'space-between',
        alignItems: 'center'
      }}>
        <Typography variant="caption" color="text.secondary">
          Mostrando {estudantesExibidos.length} de {estudantes.length} estudantes
        </Typography>

        {temMaisEstudantes && (
          <Button
            size="small"
            onClick={() => setShowAll(!showAll)}
            startIcon={showAll ? <RemoveIcon /> : <AddIcon />}
            sx={{ textTransform: 'none' }}
          >
            {showAll ? 'Ver Menos' : `Ver Todos (${estudantes.length})`}
          </Button>
        )}
      </Box>
    </>
  );
};

EstudantesAtivosTable.propTypes = {
  estudantes: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
      nome: PropTypes.string.isRequired,
      matricula: PropTypes.string.isRequired,
      infoAdicional: PropTypes.string.isRequired,
      dataIngresso: PropTypes.string.isRequired,
      status: PropTypes.string.isRequired
    })
  ),
  loading: PropTypes.bool,
  error: PropTypes.string,
  tipoInstituicao: PropTypes.string
};

EstudantesAtivosTable.defaultProps = {
  estudantes: [],
  loading: false,
  error: null,
  tipoInstituicao: null
};

export default EstudantesAtivosTable;